/**
 * True when the app is rendered inside an iframe (embedded on another site).
 * Cached on first call — safe to use in render paths.
 */
let _cached: boolean | null = null
export function isEmbedded(): boolean {
  if (_cached !== null) return _cached
  try {
    _cached = typeof window !== "undefined" && window.self !== window.top
  } catch {
    _cached = true
  }
  return _cached!
}
